'use client' // Dit moet bovenaan staan

import React, { createContext, useContext, ReactNode } from 'react'
import { Locale } from '../i18n-config'

interface TranslationContextProps {
  lang: Locale
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dictionary: any
}

const TranslationContext = createContext<TranslationContextProps | undefined>(
  undefined
)

export const useTranslation = () => {
  const context = useContext(TranslationContext)
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider')
  }
  return context
}

export const TranslationProvider = ({
  children,
  lang,
  dictionary
}: {
  children: ReactNode
  lang: Locale
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dictionary: any
}) => {
  return (
    <TranslationContext.Provider value={{ lang, dictionary }}>
      {children}
    </TranslationContext.Provider>
  )
}
